// src/redux/companyAdhoc/companyAdhocApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Create Company Adhoc
export const createCompanyAdhocAPI = async (adhocData) => {
  try {
    const endpoint = endpoints.createCompanyAdhoc;
    const response = await apiService.post(endpoint, adhocData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Adhoc Listing
export const getCompanyAdhocListingAPI = async ({
  page = 1,
  limit = 10,
  search = "",
  is_archived = "false"
} = {}) => {
  try {
    const params = { page, limit, search, is_archived };
    const response = await apiService.get(endpoints.getCompanyAdhocListing, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Adhoc Tools Candidates Count
export const getCompanyAdhocToolsCandidatesCountAPI = async ({
  page = 1,
  limit = 10,
  search = "",
  company_id
} = {}) => {
  try {
    const params = { page, limit, search, company_id };
    const response = await apiService.get(endpoints.getCompanyAdhocToolsCandidatesCount, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Adhoc Tools by Company ID
export const getCompanyAdhocToolsAPI = async (companyId) => {
  try {
    const endpoint = endpoints.getCompanyAdhocTools.replace('{companyId}', companyId);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Adhoc Detail by ID
export const getCompanyAdhocDetailAPI = async (companyId) => {
  try {
    const endpoint = endpoints.getCompanyAdhocDetail.replace('{companyId}', companyId);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Edit Company Adhoc
export const editCompanyAdhocAPI = async (companyId, adhocData) => {
  try {
    const endpoint = endpoints.editCompanyAdhoc.replace('{companyId}', companyId);
    const response = await apiService.put(endpoint, adhocData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive Company Adhoc
export const archiveCompanyAdhocAPI = async (companyId, isArchive = true) => {
  try {
    const endpoint = endpoints.archiveCompanyAdhoc.replace('{companyId}', companyId);
    const response = await apiService.put(endpoint, { is_archive: isArchive });
    return response.data;
  } catch (error) {
    throw error;
  }
};